import "antd/dist/reset.css";
import "./index.css";

import {
  ThemeProvider,
  AuthContextProvider,
  MessageContextProvider,
} from "./providers";

import Router from "./router/Router";

const App = () => {
  return (
    <ThemeProvider>
      <MessageContextProvider>
        <AuthContextProvider>
          <Router />
        </AuthContextProvider>
      </MessageContextProvider>
    </ThemeProvider>
  );
};

export default App;
